export default __webpack_public_path__ + "static/og-publicis-52ea2cb62f85c4e71e5ae1d314053036.jpg";